<div class="toggle-container" (click)="toggle()" [class.deactivated]="!active">
    <div class="on-half" [class.selected]="boolValue">
        <span>{{localize(langSection.Term, langText.On)}}</span>
    </div>
    <div class="off-half" [class.selected]="!boolValue">
        <span>{{localize(langSection.Term, langText.Off)}}</span>
    </div>
</div>